import { Grid } from '@mui/material';
import { DrawerContainer } from '~/pages/layout/components/DrawerContainer';
import { Snackbar } from '~/pages/layout/components/Snackbar';
import { DRAWER_WIDTH } from '~/shared/contants/layout-constants';

export function AppLayout({ children }: { children?: React.ReactNode }) {
  return (
    <Grid container>
      <DrawerContainer />

      <Grid
        container
        flexDirection="column"
        flexWrap="nowrap"
        height="100vh"
        width={{
          xs: '100%',
          md: `calc(100% - ${DRAWER_WIDTH}px)`,
        }}
        pb={4}
        pt={{ xs: 20, md: 4 }}
        px={4}
      >
        {children}
      </Grid>

      <Snackbar />
    </Grid>
  );
}
